import React, { useContext } from "react";
import { AUTH_APPLICATION_SECURITY, AUTH_OTP } from "@config/config";
import useAccess from "@hooks/useAccess";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext";
import { PromoContext } from "@context/PromoContext";
import { SessionContext } from "@context/SessionContext";
import BookingTotal from "@components/Bookings/BookingTotal";
import PromoCodeInput from "@components/PromoCodeInput";
import PurchasableItems from "@components/PurchasableItems";
import ReferralCodeInput from "@components/ReferralCodeInput";
import Button from "@components/Ui/Button";
import V2V3FastAuth from "@components/V3/V2V3FastAuth";
import BookSessionMessage from "@components/V3/V3BookSession/BookSessionMessage";

const BookSessionInventory = ({ handleChangeItemQuantity }) => {

    const {
        checkout,
        selectedItems,
        promoCodeSuccess,
        setError,
        checkoutBookingSession,
        setPromoCodeMessage,
        referralCode,
        setReferralCode,
        referralSuccess,
        proceedToCheckout
    } = useContext(BookSessionContext);

    const {
        session,
        purchasable,
    } = useContext(SessionContext);

    const {
        selectedPromo,
        reUseLimitReached,
    } = useContext(PromoContext);


    const { isLoggedIn, openDrawer, drawerState } = useContext(AuthContext);
    const { whiteLabel } = useContext(ApplicationContext);

    const { isFullyLoggedIn, isTempUser } = useAccess();

    const isOtpAuth = whiteLabel?.subscriber_group?.authentication_type === AUTH_OTP;
    const displayLogin = whiteLabel?.subscriber_group?.authentication_type === AUTH_APPLICATION_SECURITY;
    const checkoutText = isOtpAuth ? "Next" : (selectedPromo ? "Continue" : "Continue to checkout");
    const standardPromoCheckout = isOtpAuth ? "Next" : (checkout ? "Update Tickets" : "Checkout");
    const addTicketButtonText = isOtpAuth ? "Next" : (checkout ? "Update Tickets" : checkoutText);

    const totalTicketQuantity = selectedItems.reduce((acc, cur) => {
        return cur.type === "ticket" ? acc + cur.quantity : acc;
    }, 0);

    const handleCheckout = () => {
        if (totalTicketQuantity === 0) {
            setPromoCodeMessage("");
            setError("Please enter the quantity of tickets needed");
        } else {
            checkoutBookingSession(totalTicketQuantity, "session");
        }
    };

    const handleGuestCheckout = () => {
        if (totalTicketQuantity === 0) {
            setPromoCodeMessage("");
            setError("Please enter the quantity of tickets needed");
        } else {
            checkoutBookingSession(totalTicketQuantity, "session");
            openDrawer("fastAuthDrawer");
        }
    };

    const purchasableItemKey = (item) => {
        return item.id && item.ticket_type_id
            ? `ticket-${item.id}-${item.ticket_type_id}`
            : `candy-bar-${item.bucket_id}`;
    };

    return (
        <>
            {session.session_inventory_id == null ? (
                <div>
                    Sorry there is no inventory available to purchase for this
                    session.
                </div>
            ) : (
                <div className="v3-booking__inner">
                    <div className="v3-booking__inputs">
                        <PurchasableItems
                            items={purchasable}
                            selectedItems={selectedItems}
                            setQuantity={handleChangeItemQuantity}
                            purchasableItemKey={purchasableItemKey}
                        />

                        <BookingTotal items={selectedItems} />

                        {whiteLabel?.referral_code_flag ? (
                            <ReferralCodeInput
                                referralCode={referralCode}
                                setReferralCode={setReferralCode}
                                success={referralSuccess}
                            />
                        ) : null}

                        <div className="v3-booking__form form__group-wrapper form__group-wrapper--row">
                            <PromoCodeInput
                                success={promoCodeSuccess}
                            />

                            {isLoggedIn && isFullyLoggedIn ? (
                                <Button
                                    additionalClasses="button button__primary button--right v3-booking__cta"
                                    onClick={handleCheckout}
                                    disabled={reUseLimitReached || proceedToCheckout || drawerState.stripeCheckoutDrawer}
                                >
                                    {addTicketButtonText}
                                </Button>
                            ) : (
                                <Button
                                    additionalClasses="button button__secondary button--right"
                                    onClick={handleGuestCheckout}
                                    disabled={reUseLimitReached}
                                >
                                    {standardPromoCheckout}
                                </Button>
                            )}
                        </div>

                        {displayLogin && (!isLoggedIn || isTempUser) ? (
                            <V2V3FastAuth />
                        ) : null}
                        <BookSessionMessage />
                    </div>
                </div>
            )}
        </>
    );
};

export default BookSessionInventory;
